<template>
  <div id="app">
    <router-view name="navbar" />
    <div class="container pt-4">
      <router-view />
    </div>
  </div>
</template>
